export default {
  signInWithGoogle: "Google でサインイン",
  signInWithTwitter: "X（Twitter）でサインイン",
  signInWithDiscord: "Discord でサインイン",
  closeError: "エラーを閉じる",
  signingIn: "サインイン中...",
  authFailed: "認証に失敗しました。もう一度お試しください。",
};
